export default __webpack_public_path__ + "static/molina-healthcare-3c771c86b10af0d69dcc528e4b3bbaec.svg";